<script lang="ts" setup>
  import type { CheckboxCustomEvent } from '@ionic/core/dist/types/components/checkbox/checkbox-interface'

  const props = withDefaults(
    defineProps<{
      disabled?: boolean
      justify?: 'end' | 'space-between' | 'start'
      labelPlacement?: 'start' | 'end' | 'fixed' | 'stacked'
      name: string
    }>(),
    {
      disabled: false,
      justify: 'space-between',
      labelPlacement: 'end'
    }
  )

  const emit = defineEmits<{
    (event: 'update', value: boolean): void
    (event: 'change', payload: CheckboxCustomEvent): void
    (event: 'focus'): void
    (event: 'blur'): void
  }>()

  // use `toRef` to create reactive references to `name` prop which is passed to `useField`
  // this is important because vee-validate needs to know if the field name changes
  // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
  const name = toRef(props, 'name')

  const { value, handleBlur, handleChange } = useField<boolean>(name)

  function onInput(newValue: boolean) {
    handleChange(newValue)
  }

  function onChange(event: CheckboxCustomEvent) {
    emit('change', event)
  }

  function onFocus() {
    emit('focus')
  }

  function onBlur() {
    emit('blur')
    handleBlur()
  }
</script>

<template>
  <GCheckbox
    :disabled="props.disabled"
    :justify="props.justify"
    :label-placement="props.labelPlacement"
    :model-value="!!value"
    :name="props.name"
    @blur="onBlur"
    @change="onChange"
    @focus="onFocus"
    @update:model-value="onInput"
  >
    <slot />
  </GCheckbox>
</template>
